import { render, staticRenderFns } from "./recruitlogins.vue?vue&type=template&id=206e0fb1&scoped=true&"
import script from "./recruitlogins.vue?vue&type=script&lang=js&"
export * from "./recruitlogins.vue?vue&type=script&lang=js&"
import style0 from "./recruitlogins.vue?vue&type=style&index=0&id=206e0fb1&prod&lang=css&"
import style1 from "./recruitlogins.vue?vue&type=style&index=1&id=206e0fb1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206e0fb1",
  null
  
)

export default component.exports